// Contact page English translations

export default {
  pageTitle: "Inquiry Form",
  breadcrumbHome: "Home",
  breadcrumbContact: "Inquiry Form",
  title: "Inquiry Form",
  address: "Address",
  addressDetails: "EJIP Industrial Park, Plot 8G, Sukaresmi, Cikarang Sel., Kabupaten Bekasi, Jawa Barat 17550",
  callUs: "Call Us",
  phoneNumber: "(021) 8970178",
  emailUs: "Email Us",
  emailAddress: "sales@ekkeagle.co.id",
  yourName: "Your Name",
  yourEmail: "Your Email",
  subject: "Subject",
  message: "Message",
  sending: "Sending...",
  sendMessage: "Send Message",
  loading: "Loading",
  successMessage: "Your message has been saved and email sent (confirmation email sent to user). Thank you!",
  errorMessage: "Failed to send message",
  errorSending: "Error sending message. Please try again.",
  successAlert: "Success! Your inquiry has been submitted successfully.",
  errorAlert: "Error: "
};